import tw from 'twin.macro';

const PageTitle = tw.h1`text-gray-800 font-semibold whitespace-no-wrap text-2xl`;

export default PageTitle;
